import { IHttpRequest } from "@/interfaces/IHttp";
import { IWhitelistTerm } from "@/interfaces/languages";
import { container, TYPES } from "@/inversifyconfig/container.config";

const http = container.get<IHttpRequest>(TYPES.IHttpRequest); 


export async function listAllExclusions(): Promise<IWhitelistTerm[]> {
    const url = `translationexclusions`   

    const res = await http.get(url);
    if(res.data) {
        return Promise.resolve(res.data)
    } 
    return Promise.reject(new Error(`Could not get translation exclusion terms`))
}

export async function createNewExclusion(payload: {text: string, description?: string}): Promise<IWhitelistTerm> {
    const url = `translationexclusions`;

    const res = await http.post(url, payload);
    if(res.status === 200) {
        return Promise.resolve(res.data)
    }
    return Promise.reject(new Error(`Could not add new exclusion term`))
}

export async function updateExclusion(id: number, payload: {text: string, description: string}): Promise<IWhitelistTerm> {
    const url = `translationexclusions/${id}`;

    const res = await http.put(url, payload);
    if(res.status === 200) {
        return Promise.resolve(res.data)
    }
    return Promise.reject(new Error(`Could not update exclusion term`))
}

export async function removeExclusion(id: number) {
    const url = `translationexclusions/${id}`;

    const res = await http.delete(url);
    if(res.status === 200) {
        return Promise.resolve(true)
    }
    return Promise.reject(new Error(`Couldn't remove exclusion term`))
}